




import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'MainLayout',
})
export default class MainLayout extends Vue {}
